export default __webpack_public_path__ + "static/media/tt_no_class.14977d27.png";